export default "__VITE_ASSET__CuPqcGeP__"